import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./modules/auth/login/login.component";
import { ResetPasswordComponent } from "./modules/auth/reset-password/reset-password.component";
import { LoginGuard } from "./modules/auth/guard/login.guard";
import { RouteGuard } from "./modules/auth/guard/route.guard";
import { PermissionsResolver } from "./modules/core/resolvers/permission.resolver";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { JsonPreviewComponent } from "./modules/shared/components/json-preview/json-preview.component";

const routes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  {
    path: "json-preview",
    component: JsonPreviewComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "main",
    component: AdminLayoutComponent,
    canActivate: [LoginGuard],
    // canActivateChild: [RouteGuard],
    resolve: { data: PermissionsResolver },
    loadChildren: () =>
      import("./layouts/admin-layout/admin-layout.module").then(
        (m) => m.AdminLayoutModule
      ),
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "reset/password",
    component: ResetPasswordComponent,
  },
  { path: '**', redirectTo: 'main' },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
